module.exports = __webpack_public_path__ + "media/images/obs2-89be4f0ded9aba777c765ca2cb414ac4.png";